import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import Input from '../utils/Input';
import { updateSource, fetchSource, setSourceEdit } from '../../action/handbook';
import cn from 'classnames';
import Loader from '../utils/Loader';
import ErrorContainer from '../utils/ErrorContainer';
import { setUIvisible } from '../../action/UImobile';
import Switch from '../utils/Switch';

const styles = {
    loading: {
        minHeight: '500px',
        display: 'flex',
        justifyContent: 'center'
    }
}

class EditSource extends Component {
    componentWillUnmount() {
        this.props.setSourceEdit(null);
    }

    componentDidMount() {
        this.props.fetchSource(this.props.match.params.id).then((source) => {
            this.props.setSourceEdit(source);
        });
        this.props.setUIvisible(false, false);
    }
    
    renderSubHeader() {
        return (
            <div className="kt-subheader not-mt kt-grid__item">
                <div className="kt-container  kt-container--fluid">
                <div className="kt-subheader__main">
                    <h3 className="kt-subheader__title">{this.props.edit.name ? this.props.edit.name : 'Введите название источника*'}</h3>
                    <span className="kt-subheader__separator kt-subheader__separator--v"></span>
                </div>        
                <div className="kt-subheader__toolbar">
                    <button onClick={() => this.props.history.push('/handbook/sources')} className="btn btn-default btn-bold">
                        Назад
                    </button>
                </div>
            </div>
            </div>
        );
    }

    isValidSource() {
        const { name, value } = this.props.edit;
        if (name && value) return true;
        return false;
    }

    setSource = (field) => (e) => {
        const data = {...this.props.edit};
        if(field !== 'isAggregator') {
            data[field] = e.target.value;
        } else {
            data[field] = e;
        }
        this.props.setSourceEdit(data);
    }

    onSubmit = (e) => {
        e.preventDefault();
        const edited = { ...this.props.edit };
        this.props.updateSource(this.props.match.params.id, edited).then((result) => {
            if (result) this.props.history.push('/handbook/sources');
        });        
    }

    render() {
        const { loading, edit } = this.props;
        if (loading || !edit) {
            return (
                <div style={styles.loading}><Loader/></div>
            );
        }

        return (
            <Fragment>
                { this.renderSubHeader() }
                <div className="kt-container kt-container--fluid  kt-grid__item kt-grid__item--fluid">
                <form onSubmit={this.onSubmit} className="kt-form">
                    <div className="kt-portlet">
                        <div className="kt-portlet__body">
                            <div className="row">
                                <div className="col-md-6">
                                    <Input
                                        label="Название"
                                        required={true}
                                        onChange={this.setSource('name')}
                                        value={edit.name}
                                        placeholder="Название..."
                                    />
                                </div>
                                <div className='col-md-6'>
                                    <Input
                                        label="Значение"
                                        required={true}
                                        onChange={this.setSource('value')}
                                        value={edit.value}
                                        placeholder="Значение..."
                                    /> 
                                </div>
                                <div className='row'>
                                    <div className="col-md-6">
                                        <label className="col-10 col-form-label">Агрегатор</label>
                                        <div className="col-2">
                                            <Switch
                                                onChange={this.setSource('isAggregator')} 
                                                checked={edit.isAggregator}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="kt-portlet">
                        <ErrorContainer field="editSource" style={{ margin: '0 20px 20px' }} hasCloseButton={true}/>
                        <div className="kt-portlet__foot">
                            <div className="kt-form__actions">
                                <button
                                    disabled={!this.isValidSource() || this.props.loading}
                                    type="submit"
                                    className={cn({ 'btn btn-brand  kt-spinner--right kt-spinner--sm kt-spinner--light': true, 'kt-spinner': this.props.editCityLoader })}>
                                    Сохранить
                                </button>
                            </div>
                        </div>
                    
                </div>
                </form>
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = state => ({
    edit: state.handbook.source.edit,
    loading: state.loaders.sources,
    editCityLoader: state.loaders.editSource
});

const mapDispatchToProps = {
    setSourceEdit: (data) => setSourceEdit(data),
    fetchSource: (id) => fetchSource(id),
    updateSource: (id, data) => updateSource(id, data),
    setUIvisible: (visibleFiltersButton, visibleActionButton) => setUIvisible(visibleFiltersButton, visibleActionButton)
}

export default connect(mapStateToProps, mapDispatchToProps)(EditSource);